import { MagnifyingGlass } from "@phosphor-icons/react";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import "./index.scss";
import { useUserRole } from "../../context/userContext";
import { fetchProductSearch, fetchStoriesSearch, fetchWebfeedSearch } from "./apiService";
import { Link } from "react-router-dom";

function Home() {
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [product, setProduct] = useState({});
  const [stories, setStories] = useState({});
  const [webFeed, setWebFeed] = useState({});
  const { handleSubmit, register } = useForm();
  const userRole = useUserRole();

  const fetchData = async (fetchFunc, setData, search, errorMessage) => {
    const page = 1;
    const pageSize = 2;
    setButtonDisabled(true);
    try {
      const data = await fetchFunc(page, pageSize, search, userRole);
      setData(data || {});
    } catch (error) {
      console.error(errorMessage, error);
    } finally {
      setButtonDisabled(false);
    }
  };

  const fetchAllData = (search) => {
    fetchData(fetchProductSearch, setProduct, search, "Error fetching partnerships:");
    fetchData(fetchStoriesSearch, setStories, search, "Error fetching stories:");
    fetchData(fetchWebfeedSearch, setWebFeed, search, "Error fetching web feeds:");
  };

  const onSubmit = (data) => {
    fetchAllData(data.prompt);
  };

  const handleInputChange = (e) => {
    const search = e.target.value;
    if (search) {
      fetchAllData(search);
    } else {
      setProduct({});
      setStories({});
      setWebFeed({});
    }
  };
  // console.log("product?.data?.length",product?.data?.length,product?.data)
  return (
    <div className="flex items-center home-container m-auto mt-8">
      <div className="flex flex-col">
        <h1 className="text-5xl font-semibold text-center">SaaS Research, Simplified</h1>
        <p className="mt-3 mx-10 text-base text-center">
          Discover top-tier SaaS solutions, unlock new partnerships, explore templates, and dive into inspiring stories.
        </p>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="pl-4 pr-2 py-2 rounded-lg w-full partner-border flex mt-5 mb-3 bg-white items-center"
        >
          <MagnifyingGlass size={20} />
          <input
            type="text"
            className="border-0 w-full outline-none indent-2"
            placeholder="Enter keywords to describe what you are looking for"
            {...register("prompt", { required: true })}
            onChange={handleInputChange}
          />
          <button className="bg-purple-saas22 p-2 rounded-md chatgpt-button" type="submit" disabled={buttonDisabled}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="#fff"
              className="size-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
              />
            </svg>
          </button>
        </form>

        {(product?.data?.length > 0 || stories?.data?.length > 0 || webFeed?.data?.length > 0) && (
          <div className="bg-white search-results-container text-left rounded-sm">
            <div className="flex flex-col m-6">
              <div className="pt-3">
                <h4 className="text-base font-semibold">Products</h4>
                {product?.data?.length > 0 ? (
                  product.data.map((data) => (
                    <Link to={`/partnerships/partnerDetail/${data.attributes.vendor.data.id}`}>
                      <div className="flex items-center flex-row pt-4" key={data.id}>
                        <img src={data?.attributes.logo.data?.attributes?.url} alt="logo" />
                        <p className="pl-3 text-sm">{data.attributes.title}</p>
                      </div>
                    </Link>
                  ))
                ) : (
                  <p>No Products found</p>
                )}
              </div>
              <hr className="mt-5 silver" />
              <div className="pt-3">
                <h4 className="text-base font-semibold">Stories</h4>
                {stories?.data?.length > 0 ? (
                  stories.data.map((data) => (
                    <Link to={`/story/${data.id}/${data.attributes.slug}`}>
                      <p className="text-sm pt-4" key={data.id}>
                        {data.attributes.title}
                      </p>
                    </Link>
                  ))
                ) : (
                  <p>No Stories found</p>
                )}
              </div>
              <hr className="mt-5 silver" />
              <div className="pt-3">
                <h4 className="text-base font-semibold">Web Feeds</h4>
                {webFeed?.data?.length > 0 ? (
                  webFeed.data.map((data) => (
                    <Link to={`${data.attributes.externalLink}`}>
                      <p className="text-sm pt-4" key={data.id}>
                        {data.attributes.title}
                      </p>
                    </Link>
                  ))
                ) : (
                  <p>No Web Feeds found</p>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Home;
